var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManualGrab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.828,
    height: 78.731,
    viewBox: "0 0 78.828 78.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14839",
    "data-name": "Group 14839",
    transform: "translate(0.501 0.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11357",
    "data-name": "Path 11357",
    d: "M53.02,15.612a28.518,28.518,0,0,0-2.651-2.4c-10.318-7.667-25.079-4.12-33.1-1.4a3.583,3.583,0,0,0-2.365,3.4V82.21a3.584,3.584,0,0,0,3.576,3.59,3.625,3.625,0,0,0,1.584-.365,33.079,33.079,0,0,1,11.465-2.974h2.794a34.228,34.228,0,0,1,14.331,3.224,3.582,3.582,0,0,0,4.794-1.641,3.625,3.625,0,0,0,.365-1.584V18.048A3.575,3.575,0,0,0,53.02,15.612Z",
    transform: "translate(24.013 -8.576)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11373",
    "data-name": "Path 11373",
    d: "M15.693,15.612a28.518,28.518,0,0,1,2.651-2.4c10.318-7.667,25.079-4.12,33.1-1.4a3.583,3.583,0,0,1,2.365,3.4V82.21a3.584,3.584,0,0,1-3.576,3.59,3.625,3.625,0,0,1-1.584-.365,33.078,33.078,0,0,0-11.465-2.974H34.395a34.228,34.228,0,0,0-14.331,3.224,3.582,3.582,0,0,1-4.794-1.641,3.625,3.625,0,0,1-.365-1.584V18.048A3.575,3.575,0,0,1,15.693,15.612Z",
    transform: "translate(-14.9 -8.576)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualGrab);
export default __webpack_public_path__ + "static/media/manual-grab.0f4b309887fffadcdeb0a2419b698e21.svg";
export { ForwardRef as ReactComponent };